import Page from "../pages/Scholarship";
import { pageMeta } from "../lib/meta";
import { liveOffers } from "../lib/offers";
import type { Route } from "./+types/scholarship";
import { OG_IMAGE } from "../config/heroArt";

export async function loader() {
  // The round is closed, so this page's job is to hand the reader whatever IS
  // open. That comes from the Maven table like everywhere else.
  return { offers: await liveOffers() };
}

export const meta = () =>
  pageMeta({
    title: "Scholarship seats: applications closed | Gazar",
    description:
      "The scholarship round for the Maven cohort on production LLM and agent systems has ended. See the next free live session and the courses running now.",
    path: "/scholarship",
    image: OG_IMAGE.lessons,
  });

export default function Scholarship({ loaderData }: Route.ComponentProps) {
  return <Page offers={loaderData.offers} />;
}
